import 'phaser'
import { perf } from '../engine/perf-sidecar'
import { pubSub } from '../engine/pubSub-sidecar'
import { voyageScene } from '../proto/voyage/voyageScene-sidecar'
import { common } from './common-sidecar'
import { preloader } from './preloader-sidecar'

type GameMode = 'voyage'
const gameMode: GameMode = 'voyage'

const w = window.innerWidth
const h = window.innerHeight
export const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  // mode: Phaser.NONE,
  //backgroundColor: '#0c1013', //'#191324',
  backgroundColor: '#000000', //'#191324',
  disableContextMenu: true,
  width: w,
  height: h,
  scene: {
    preload: preload,
    create: create,
    update: update,
    pack: {
      files: [
        // {
        //   type: 'scenePlugin',
        //   key: 'SpinePlugin',
        //   url: 'plugins/SpinePlugin.js',
        //   sceneKey: 'spine',
        // },
      ],
    },
  },
  parent: 'phaser-root',
  pixelArt: true,
  input: {
    gamepad: true,
  },
  pipeline: {
    // HueRotatePipelinePostFX,
    // MosaicPipelinePostFX,
    // DiamondWipePipelinePostFX,
  } as any,
} as any

export const game = new Phaser.Game(config)

window.addEventListener(
  'resize',
  (event) => {
    game.scale.resize(window.innerWidth, window.innerHeight)
    pubSub.emit('browser:resize', {
      w: window.innerWidth,
      h: window.innerHeight,
    })
  },
  false,
)

function preload() {
  // let load = this.load
  perf.mark('preload')
  preloader.preloadAssets(this.load)
}

function create() {
  perf.mark('preload done')
  game.canvas.oncontextmenu = (ev) => {
    ev.preventDefault()
  }

  common.setPhaserScene(this)

  if (gameMode === 'voyage') {
    voyageScene.create()
  }
}

function update(time: number, delta: number) {
  if (gameMode === 'voyage') {
    voyageScene.update(time, delta)
  }
}
